import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { connect } from "react-redux";
import { normalizePhone } from "../../helpers";
import { showMessageModal } from "../../redux/modules/Modal";
import { sendOtp } from "../../redux/modules/Otp";
import { uniquePhone } from "../../redux/modules/UniqueField";
import countryCodes from "../../resources/general/CountryCode";
import countryNames from "../../resources/general/CountryName";
import TextField from "../components/fields/TextField";
import Button from "../components/forms/Button";

const countryCodeOptions = [];
Object.keys(countryCodes).map(key => {
  if (countryNames[key]) {
    let countryName = countryNames[key];
    if (countryName.length >= 12)
      countryName = countryName.substr(0, 10) + "...";
    return countryCodeOptions.push({
      value:
        countryCodes[key][0] === "+"
          ? countryCodes[key]
          : `+${countryCodes[key]}`,
      label:
        countryCodes[key][0] === "+"
          ? `${countryName} (${countryCodes[key]})`
          : `${countryName} (+${countryCodes[key]})`
    });
  } else return;
});

const getMobileNumberValue = (value, defaultCode, selectedValue, type) => {
  let parts = value ? value.split("-") : [];
  let code = parts[0] ? parts[0] : defaultCode;
  let number = parts[1] ? parts[1] : "";
  if (type === "code") {
    code = selectedValue;
  } else {
    number = selectedValue;
  }
  const updatedValue = `${code}-${number}`;
  return value !== updatedValue ? updatedValue : null;
};

const MobileNumberField = props => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [isDisabled, setIsDisabled] = useState(false);
  const [isValidPhone, setIsValidPhone] = useState(false);
  const [time, setTime] = useState({});

  const theForm = useRef(null);
  let timer;
  let seconds = 30;

  useEffect(() => {
    let timeLeftVar = secondsToTime(seconds);
    setTime(timeLeftVar);
  }, []);

  const handleRecaptchaVerify = async () => {
    if (!executeRecaptcha) {
      return;
    }

    const token = await executeRecaptcha("get_otp");

    handleSendOtp(token);
  };

  const secondsToTime = secs => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let s = Math.ceil(divisor_for_seconds); //seconds

    let obj = {
      h: hours,
      m: minutes,
      s
    };
    return obj;
  };

  const startTimer = () => {
    if (!timer && seconds > 0) {
      timer = setInterval(countDown, 1000);
    }
  };

  const countDown = () => {
    // Remove one second, set state so a re-render happens.
    seconds--;
    setTime(secondsToTime(seconds));

    // Check if we're at zero.
    if (seconds === 0) {
      seconds = 30;
      setIsDisabled(false);
      clearInterval(timer);
      timer = null;
    }
  };

  const validateMobileNo = (mobileNo, enableErrorPopup = true) => {
    if (mobileNo.length === 0) return;
    if (mobileNo.length !== 8) {
      if (enableErrorPopup) {
        props.dispatch(showMessageModal("Mobile must be 8 numeric characters"));
      }
      return false;
    }
    if (!(mobileNo[0] === "8" || mobileNo[0] === "9")) {
      if (enableErrorPopup) {
        props.dispatch(showMessageModal("Mobile must be Singapore number"));
      }
      return false;
    }

    return true;
  };

  const handleOnBlur = (selectedValue, type) => {
    const { value, onBlur } = props.input;
    const newValue = getMobileNumberValue(
      value,
      props.defaultCode,
      selectedValue,
      type
    );
    if (newValue) onBlur(newValue);
    validateMobileNo(selectedValue + "");
  };

  const handleOnBlurOtp = (selectedValue, type) => {
    const { value, onBlur } = props.input;
    const newValue = getMobileNumberValue(
      value,
      props.defaultCode,
      selectedValue,
      type
    );
    if (newValue) onBlur(newValue);
    validateMobileNo(selectedValue + "");
  };

  const handleCodeChange = selectedOption => {
    const selectedCode =
      selectedOption && selectedOption.value ? selectedOption.value : null;
    const { value, onChange } = props.input;
    const newValue = getMobileNumberValue(
      value,
      props.defaultCode,
      selectedCode,
      "code"
    );
    if (newValue) onChange(newValue);
  };

  const handleNumberChange = inputValue => {
    setIsValidPhone(validateMobileNo(inputValue + "", false));
    console.log(inputValue, isValidPhone);

    const number = inputValue;
    const {
      input: { value, onChange },
      defaultCode
    } = props;
    const newValue = getMobileNumberValue(value, defaultCode, number, "number");
    if (newValue) onChange(newValue);
  };

  const handleSendOtp = recaptchaToken => {
    if (isValidPhone) {
      setIsDisabled(true);
      startTimer();

      const { mobileNo } = theForm.current;
      let mobile = mobileNo.value;
      let phoneNumber = props.defaultCode + mobile;
      return props.dispatch(
        uniquePhone(mobile, () => {
          props.handleInputOTP(true);
          doSendOtp(phoneNumber, recaptchaToken);
        })
      );
    }
  };

  const doSendOtp = async (phoneNumber, recaptchaToken) => {
    props.dispatch(sendOtp(phoneNumber, recaptchaToken));
  };

  const {
    input: { value },
    label,
    minLength,
    required,
    translate,
    disabled,
    children,
    defaultCode,
    minLengthMobile,
    isLogIn,
    meta: { touched, error },
    handleInputOTP
    // ...props
  } = props;
  const parts = value.split("-");
  const countryCode = parts[0] ? parts[0] : defaultCode;
  const number = parts[1] ? parts[1] : "";
  countryCodeOptions.sort((a, b) => {
    if (a.label > b.label) return 1;
    if (a.label < b.label) return -1;
    return 0;
  });

  return (
    <form ref={theForm}>
      <div className="form-group mob">
        {isLogIn ? (
          <div className="row">
            <div className={classnames("country col-lg-3 col-md-3 col-3")}>
              <TextField
                input={{
                  name: "country",
                  value: defaultCode
                }}
                type="text"
                hideLabel={true}
                // required={true}
                disabled={true}
                meta={{ touched }}
              />
            </div>
            <div
              className={classnames(
                "mobileNo col-lg-9 col-md-9 text-left col-9"
              )}
            >
              <TextField
                input={{
                  name: "mobileNo",
                  value: number,
                  onChange: evt => handleNumberChange(evt.target.value),
                  onBlur: evt => handleOnBlur(evt.target.value, "number")
                }}
                type="number"
                normalize={normalizePhone}
                autocomplete="phone"
                required={true}
                label="Mobile No "
                hideLabel={true}
                // onBlur={this.validateName}
                // minLengthMobile={8}
                // disabled={disabled}
                meta={{ touched }}
              />
              <div className="invalid-feedback">{""}</div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className={classnames("country col-lg-3 col-md-3 col-3 pr-2")}>
              <TextField
                input={{
                  name: "country",
                  value: defaultCode
                }}
                type="text"
                hideLabel={true}
                // required={true}
                disabled={true}
                meta={{ touched }}
              />
            </div>
            <div
              className={classnames(
                "mobileNo col-lg-5 col-md-5 text-left col-5 px-0"
              )}
            >
              <TextField
                input={{
                  name: "mobileNo",
                  value: number,
                  onChange: evt => handleNumberChange(evt.target.value),
                  onBlur: evt => handleOnBlurOtp(evt.target.value, "number")
                }}
                type="number"
                normalize={normalizePhone}
                autocomplete="phone"
                required={true}
                label="Mobile No "
                hideLabel={true}
                // disabled={disabled}
                meta={{ touched }}
              />
            </div>
            <div
              className={classnames(
                "btn-getOtp col-lg-4 col-md-4 col-4 pl-2 py-0"
              )}
            >
              <div className="textbox-container text-right">
                <Button
                  className="w-100 "
                  style={{
                    backgroundColor:
                      !isDisabled && isValidPhone ? "#8fbe3e" : null
                  }}
                  onClick={() => {
                    if (!isValidPhone) return;
                    handleRecaptchaVerify();
                  }}
                  type="button"
                  disabled={isDisabled ? true : false}
                >
                  {isDisabled ? time.s + "s" : "Get OTP"}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      {children}
    </form>
  );
};

MobileNumberField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  meta: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

MobileNumberField.defaultProps = {
  // input: {
  //   value: "+81-8080809090"
  // }
};

export default connect()(MobileNumberField);



// WEBPACK FOOTER //
// ./src/views/modules/MobileNumberField.js